import { Status } from "./screens/status/Status";

export const MainContent: React.FC = () => {
  return <Status />
};
